import { useQuery } from 'react-query';
import type { UseQueryResult } from 'react-query';

import { getRawHeatData } from '../api/api';

const RAW_HEAT_DATA_QUERY_KEY = 'raw_heat_data';

interface useHeatmapRawDataReturnedValue {
  rawHeatData: UseQueryResult<HeatmapAPI.GetRawHeatResponse, Error>;
}

export interface UseHeatmapRawDataParams {
  heatmapType: HeatmapDataType;
  siteId: SiteId;
  deviceType: HeatmapDeviceTypes;
  url: string;
  matchOperation: TargetingValue;
  jsonQueryString: string;
  enabled: boolean;
}

export const useHeatmapsRawData = ({
  siteId,
  deviceType,
  heatmapType,
  url,
  matchOperation,
  jsonQueryString,
  enabled,
}: UseHeatmapRawDataParams): useHeatmapRawDataReturnedValue => {
  const rawHeatData = useQuery<HeatmapAPI.GetRawHeatResponse, Error>(
    [
      RAW_HEAT_DATA_QUERY_KEY,
      { siteId, deviceType, url, matchOperation, heatmapType, jsonQueryString },
    ],
    () => getRawHeatData({ siteId, deviceType, url, matchOperation, heatmapType, jsonQueryString }),
    {
      retry: false,
      refetchOnWindowFocus: false,
      enabled,
    },
  );

  return {
    rawHeatData,
  };
};
